import { render, staticRenderFns } from "./ElectricBill.vue?vue&type=template&id=3eff8e3f&"
import script from "./ElectricBill.vue?vue&type=script&lang=js&"
export * from "./ElectricBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports